import { useSelector } from 'react-redux'

import { isSingleSelector } from 'selectors/current_organization'

import { Placeholder } from './placeholder'
import { UsersStats } from './users_stats'

export const Users = () => {
  const isSingleOrganization = useSelector(isSingleSelector)

  return (
    isSingleOrganization ? <Placeholder /> : <UsersStats />
  )
}
